<span style="padding-right: 10px;"
     *ngFor="let transition of listTransitions">
  <span [matTooltip]="disabledReason" [matTooltipDisabled]="!disabled" [matTooltipClass]="'tooltip'">
    <button
            mat-raised-button
            [disabled]="disabled"
            type="button"
            (click)="click(transition)"
            [ngClass]="getColorButton(transition.transition)"
            [matTooltipDisabled]="disabled"
            matTooltip="{{getLabelButton(transition.transition)}}">
      {{getLabelButton(transition.transition)}}
    </button>
  </span>
</span>
